import {useContext, useEffect, useState} from 'react'
import CostAnalysisReportChildTable from './CostAnalysisReportChildTable'
import {CostAnalysisReportContext} from '../../context'

const CostAnalysisReportTableRow = ({row}: any) => {
  const [showRow, setShowRow] = useState(false)
  const {isLoading} = useContext(CostAnalysisReportContext)

  useEffect(() => {
    if (!isLoading) {
      setShowRow(false)
    }
  }, [isLoading])

  const handleToggleChildTable = async () => {
    if (!row.sku) return
    setShowRow((prev) => !prev)
  }

  return (
    <>
      <tr>
        <td className='text-center ps-2'>
          <button onClick={handleToggleChildTable} className='bg-light'>
            <i
              className={`bi ${
                showRow
                  ? 'bi bi-dash-circle fs-3 fw-semibold cursor-pointer'
                  : 'bi bi-plus-circle fs-3 fw-semibold cursor-pointer'
              } fs-5`}
            ></i>
          </button>
        </td>
        <td>{row.productName}</td>
        <td>{row.sku}</td>
        <td>{row.currentCostPrice}</td>
        <td
          className={
            row?.costMargin < 0 ? 'text-danger' : row?.costMargin === null ? '' : 'text-success'
          }
        >
          {row.costMargin !== null ? `${row.costMargin}%` : '-'}
        </td>
        <td>{row.lastPoCostPrice}</td>
        <td>
          <div>{row.averageCostOfLast3Pos}</div>
        </td>
        <td onClick={handleToggleChildTable}>
          <span className='badge badge-light-primary cursor-pointer'>SEE PO DETAILS</span>
        </td>
      </tr>
      {showRow && (
        <tr>
          <td colSpan={8}>
            <CostAnalysisReportChildTable
              childData={row?.variants}
              minVariantCostPrice={row?.minVariantCostPrice}
            />
          </td>
        </tr>
      )}
    </>
  )
}

export default CostAnalysisReportTableRow
